// 테마 키는 DESIGN §5 고정: localStorage["centium.theme"] = light | dark | system
export type ThemeMode = "light" | "dark" | "system";
export const THEME_KEY = "centium.theme";

export function readTheme(): ThemeMode {
  try {
    const v = localStorage.getItem(THEME_KEY);
    if (v === "light" || v === "dark" || v === "system") return v;
  } catch { /* 저장소 차단 — 시스템 설정으로 */ }
  return "system";
}

const mq = () => window.matchMedia("(prefers-color-scheme: dark)");
let watching = false;

/** system 이면 OS 설정을 읽어 data-theme 를 light|dark 로 확정해 둔다(감사기가 data-theme 를 본다) */
export function applyTheme(mode: ThemeMode) {
  const dark = mode === "dark" || (mode === "system" && mq().matches);
  document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
  if (!watching) {
    watching = true;
    // 시스템 모드일 때 OS 설정이 바뀌면 따라간다
    mq().addEventListener("change", () => { if (readTheme() === "system") applyTheme("system"); });
  }
}
